// @flow
import React, { Component } from "react";
import logo_path from "../images/logo.svg";

type Props = {
	style?: any,
};
type State = {};
class Logo extends Component<Props, State> {
	render() {
		return (
			<img
				alt="Focus 45"
				src={logo_path}
				style={{ maxWidth: "200px", width: "100%", ...this.props.style }}
			/>
		);
	}
}

export default Logo;



// WEBPACK FOOTER //
// ../shared/components/Logo.js